/* src/app/shared/components/dialer/dialer.component.scss */
/*# sourceMappingURL=dialer.component.css.map */
